import { QueryError, ApiRoutes } from '../../../common/interfaces';
import { buildMutation, apiExecutor } from '../../../common/services';
import { ProxyServerAddress } from '../entities';
import { ProxyServerAddressesQueryKeys } from './proxy-servers.keys';

export const useAutocompleteProxyServerAddressesMutation = () =>
  buildMutation<Pick<ProxyServerAddress, 'id' | 'ip' | 'configurationStatus' | 'healthStatus'>[], QueryError, string>(
    [ProxyServerAddressesQueryKeys.Autocomplete],
    async (proxyServerId) => {
      const { data } = await apiExecutor.get<Pick<ProxyServerAddress, 'id' | 'ip' | 'configurationStatus' | 'healthStatus'>[]>(
        ApiRoutes.ProxyServerAddressesAutocomplete.replace(':proxyServerId', proxyServerId),
      );
      return data;
    },
  );
